import * as tslib_1 from "tslib";
import ErrorPage from "@ivy/fts/inner/404.vue";
import { Component, Vue } from 'vue-property-decorator';
let Error = class Error extends Vue {
};
Error = tslib_1.__decorate([
    Component({
        components: { ErrorPage }
    })
], Error);
export default Error;
